import { RotaButtonIcon, RotaNewModal, iconNew } from "@teamrota/rota-design";
import React from "react";
import {
  ButtonsContainer,
  StyledModalHeader,
  ReserveButton,
  AssignButton,
  CancelButton
} from "./index.styles";

const { Cancel } = iconNew;

const ReservedBookingModal = ({ onClose, onConfirm, partnerName }) => {
  const handleReserve = () => {
    onConfirm({
      bookingState: "RESERVED"
    });
  };

  const handleAssign = () => {
    onConfirm({
      bookingState: "ACCEPTED"
    });
  };

  return (
    <RotaNewModal
      onClose={onClose}
      size={"small"}
      header={
        <StyledModalHeader
          title="Reservations Enabled"
          endAction={
            <RotaButtonIcon onClick={onClose}>
              <Cancel />
            </RotaButtonIcon>
          }
        />
      }
      footer={
        <ButtonsContainer>
          <ReserveButton onClick={handleReserve}>Reserve</ReserveButton>
          <AssignButton onClick={handleAssign}>Assign</AssignButton>
          <CancelButton onClick={onClose}>Cancel</CancelButton>
        </ButtonsContainer>
      }
    >
      <div>
        <div>
          Booking reservations are enabled for{" "}
          <span style={{ fontWeight: "bold" }}>{partnerName}</span>. How do you
          want to book this candidate?
        </div>
      </div>
    </RotaNewModal>
  );
};

export default ReservedBookingModal;
